import { withTranslation } from "next-i18next";
import InputButtonsSameSize from "@components/core/InputButtonsSameSize";
import { setTypeOfCatalogGrid } from "@utils/user-preferences-cookies/typeOfCatalogGrid";
import classNames from "classnames";
import catalogContexts from "@utils/constants/catalogContexts";

const radioButtonsList = {
  mobile: [
    {
      value: "big-pictures",
      leftIconName: "square",
    },
    {
      value: "small-pictures",
      leftIconName: "columns",
    },
  ],
  desktop: [
    {
      value: "big-pictures",
      leftIconName: "columns",
    },
    {
      value: "small-pictures",
      leftIconName: "grid",
    },
  ],
};

const CatalogGridButtonsContainer = ({ typeOfGrid, setTypeOfGrid, context }) => {
  function onValueChange(value) {
    setTypeOfCatalogGrid(value);
    setTypeOfGrid(value);
  }

  return (
    <div
      className={classNames("py-2 bg-body", context === catalogContexts.sales && "sales-context")}
    >
      <div className="d-flex justify-content-end flex-column">
        <div className="d-flex justify-content-between align-items-center mt-1 mt-md-0">
          <InputButtonsSameSize
            containerClassName="d-lg-none"
            size="sm"
            options={radioButtonsList.mobile.map((btn) => ({
              leftIconName: btn.leftIconName,
              value: btn.value,
            }))}
            selectedValues={[typeOfGrid]}
            onClick={(value) => onValueChange(value)}
          />
          <InputButtonsSameSize
            containerClassName="d-none d-lg-flex"
            size="sm"
            options={radioButtonsList.desktop.map((btn) => ({
              leftIconName: btn.leftIconName,
              value: btn.value,
            }))}
            selectedValues={[typeOfGrid]}
            onClick={(value) => onValueChange(value)}
          />
        </div>
      </div>
    </div>
  );
};

export default withTranslation("catalog")(CatalogGridButtonsContainer);
